module.exports = __webpack_public_path__ + "static/media/pw.667ce732.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pw.svg
// module id = 1336
// module chunks = 0